import React from 'react';
import {
  unstable_renderSubtreeIntoContainer as render,
  unmountComponentAtNode,
} from 'react-dom';
import styles from './style.module.scss';

/* eslint-disable react/no-unused-prop-types */

// This class extends google.maps.OverlayView,
// but the API is loaded asynchronously, so we create this class on demand.
export default function createMarkerContainerClass(google) {
  class MarkerContainer extends google.maps.OverlayView {
    constructor(props, parent) {
      super(props);
      this.setProps(props);
      this.parent = parent;
    }

    get overlay() {
      return this.getPanes().overlayImage;
    }

    setProps(props) {
      this.props = props;
      this.pos = new google.maps.LatLng(props.position.lat, props.position.lng);
      if (this.div) {
        this.onRemove();
        this.onAdd();
      }
    }

    onRemove() {
      if (this.div) {
        unmountComponentAtNode(this.div);
        if (this.div.parentElement)
          this.div.parentElement.removeChild(this.div);
        delete this.div;
      }
    }

    onAdd() {
      const div = document.createElement('DIV');
      if (this.props.id) div.id = this.props.id;
      div.className = `${styles.mapMarker} ${
        this.props.hideFrame ? '' : styles.defaultMapMarker
      } ${this.props.className || ''}`;
      if (this.props.style) {
        Object.keys(this.props.style).forEach((key) => {
          div.style[key] = this.props.style[key];
        });
      }

      this.overlay.appendChild(div);
      if (this.props.onMouseEnter)
        google.maps.event.addDomListener(
          div,
          'mouseenter',
          this.props.onMouseEnter
        );
      if (this.props.onMouseLeave)
        google.maps.event.addDomListener(
          div,
          'mouseleave',
          this.props.onMouseLeave
        );
      if (this.props.onClick)
        google.maps.event.addDomListener(div, 'click', this.props.onClick);
      this.div = div;
    }

    updatePosition() {
      const projection = this.getProjection();
      const position = projection.fromLatLngToDivPixel(this.pos);
      this.div.style.position = 'absolute';
      this.div.style.left = position.x + 'px';
      this.div.style.top = position.y + 'px';
    }

    draw() {
      if (!this.div) return;
      render(this.parent, this.props.children || <div />, this.div);
      this.updatePosition();
    }
  }
  return MarkerContainer;
}
